module.exports = __webpack_public_path__ + "static/media/smile.553bcfd3.svg";